import type { IAppCommandPromptProvider, IAppCommandPromptResultGroup, IAppCommandPromptResultItem } from "./appcommandprompt";
import { getMyCustomers } from "@@customer/api/customer";
import { inwinkSearchCommand } from "./appcommandpromptcontext";

export class CustomersSearchCommand implements IAppCommandPromptProvider {
    trigger = inwinkSearchCommand;
    name = "customerssearch";

    customersPromise: Promise<any>;

    search(search: string) : Promise<IAppCommandPromptResultGroup[]> {
        if (this.customersPromise == null) {
            this.customersPromise = getMyCustomers();
        }
        return this.customersPromise.then((customers) => {
            var items = customers.filter((customer) => {
                return customer.customerId == search
                    || (customer.companyName && customer.companyName.toLowerCase().indexOf(search.toLowerCase()) >= 0);
            }).map((customer) => {
                const item: IAppCommandPromptResultItem = {
                    id: customer.customerId,
                    label: customer.companyName,
                    link: '/' + customer.customerId,
                    rawdata: customer
                }
                return item;
            });

            if (items && items.length) {
                const group: IAppCommandPromptResultGroup = {
                    label: "quicksearch.customer",
                    items: items,
                }
                return [group];
            }
        }, (err) => {
            console.error("error searching customers", err);
            this.customersPromise = null;
            return null;
        });
    }
}